import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
const actions = ['Esamina il materiale.', 'Consulta gli algoritmi clinici.', 'Utilizza i modelli.', 'Applica i protocolli.'];
export function GuaranteeSection() {
  return <section className="w-full bg-white" data-id="element-175" data-mp="1fcskzqlqikls">
      <div className="mx-auto w-full max-w-3xl px-5 py-14 sm:px-8 sm:py-20" data-id="element-176" data-mp="1fbptphki2g5c">
        <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.2em] text-teal" data-id="element-177" data-mp="1ae7n3xtygd0i">
          Il tuo investimento è completamente senza rischi
        </p>

        <div className="mt-6 flex flex-col items-center" data-id="element-178" data-mp="11czzqasz8wl7">
          <span className="flex h-20 w-20 items-center justify-center rounded-full bg-teal-soft ring-4 ring-teal/20" data-id="element-179" data-mp="11djituud5r0t">
            <ShieldCheckIcon className="h-10 w-10 text-teal" aria-hidden="true" data-id="element-180" data-mp="wfzt9ys7trtk" />
          </span>
          <h2 className="mt-5 text-balance text-center font-display text-[28px] font-black leading-[1.12] tracking-[-0.02em] text-plum-deep sm:text-4xl" data-id="element-181" data-mp="2vq9ae5x9eo51">
            Garanzia soddisfatti o rimborsati di 7 giorni
          </h2>
        </div>

        <ul className="mx-auto mt-7 grid max-w-xl grid-cols-1 gap-2.5 sm:grid-cols-2" data-id="element-182" data-mp="1l4g352b7c2uo">
          {actions.map(action => <li key={action} className="rounded-xl bg-cream px-4 py-3 text-center text-[14.5px] font-semibold text-ink/75 ring-1 ring-ink/10 sm:text-[15px]" data-id="element-183" data-mp="1756x2vgpmp4f">
              {action}
            </li>)}
        </ul>

        <p className="mx-auto mt-7 max-w-2xl text-center text-[15.5px] leading-relaxed text-ink/75 sm:text-base" data-id="element-184" data-mp="23u67oh4ro2zs">
          Se, entro i prossimi 7 giorni, non ritieni che il Progetto Clinico della Menopausa™ ti
          aiuti a prendere decisioni cliniche più rapide e sicure, contatta semplicemente il nostro
          team di supporto. Ti rimborseremo il 100% dell’acquisto.
        </p>

        <p className="mt-4 text-center text-[16px] font-extrabold text-plum sm:text-lg" data-id="element-185" data-mp="2nif10ui1qf0v">
          Nessun modulo complicato. Nessuna domanda. Nessun rischio.
        </p>

        <div className="mx-auto mt-8 max-w-xl" data-id="element-186" data-mp="2xdm5sq0vbnuq">
          <CTAButton label="Provalo senza rischi per 7 giorni" sub="Rimborso del 100% se non fa per te" variant="teal" data-id="element-187" data-mp="2sercuv96siww" />
        </div>
      </div>
    </section>;
}